import React from 'react'
import Appreciation from './Indicators/Appreciation'
import MarketTemp from './Indicators/MarketTemp'
import RentalPotential from './Indicators/RentalPotential'

const IndicatorContainer = () => {
  return (
    <>
      <MarketTemp />
      <Appreciation />
      <RentalPotential />
    </>
  )
}

export default IndicatorContainer
